import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { initialLanguage, newBaseUrl } from "../Consts"

export const ProductsContext = createContext();
export const useProducts = () => {
    return useContext(ProductsContext);
};

export default function ProductsContextProvider({ children }) {
    const [isProducts, setIsProducts] = useState();
    const [isProductsBrands, setIsProductsBrands] = useState();
    const [isProductsSubBrands, setIsProductsSubBrands] = useState();
    const [isProductsCategory, setIsProductsGategory] = useState();
    const [isProduct, setIsProduct] = useState();
    const [isBanners, setIsBanners] = useState();
    const [isProductsByCategory, setIsProductsByGategory] = useState();

    const headers = {
        'Content-Type': 'application/json',
        'Content-Language': initialLanguage
    };

    async function getProducts() {
        try {
            const res = await axios.get(`${newBaseUrl}/api/products`, { headers });
            // console.log(res?.data);
            setIsProducts(res?.data)
        } catch (err) {
            // console.error(err);
        }
    }

    async function getProductById(id) {
        setIsProduct()
        try {
            const res = await axios.get(`${newBaseUrl}/api/product/${id}`, { headers });
            // console.log(res?.data);
            setIsProduct(res?.data)
        } catch (err) {
            setIsProduct(null)
        }
    }

    async function getProductsByCategory(id) {
        try {
            const res = await axios.get(`${newBaseUrl}/api/products-category/all`, { headers });
            // console.log(res?.data);
            setIsProductsByGategory(res?.data)
        } catch (err) {
            // console.error(err);
        }
    }

    async function getProductsCategory() {
        try {
            const res = await axios.get(`${newBaseUrl}/api/products-category`, { headers });
            // console.log(res?.data?.data);
            setIsProductsGategory(res?.data)
        } catch (err) {
            // console.error(err);
        }
    }

    async function getProductsBrands() {
        try {
            const res = await axios.get(`${newBaseUrl}/api/products-brands`, { headers });
            setIsProductsBrands(res?.data)
            // console.log(res?.data?.data);
        } catch (err) {
            // console.error(err);
        }
    }

    async function getProductsSubBrands(id) {
        setIsProductsSubBrands();
        try {
            const res = await axios.get(`${newBaseUrl}/api/products-subbrands/${id}`, { headers });
            setIsProductsSubBrands(res?.data)
            console.log(res?.data?.data);
        } catch (err) {
            setIsProductsSubBrands(null);
            // console.error(err);
        }
    }

        async function getBanners() {
        try {
            const res = await axios.get(`${newBaseUrl}/api/fitout`, { headers });
            console.log(res?.data);
            setIsBanners(res?.data)
        } catch (err) {
            console.error(err);
        }
    }

    return <ProductsContext.Provider value={{
        getProducts, getProductsCategory, getProductsBrands, getProductsSubBrands, getProductById, getProductsCategory, getProductsByCategory, getBanners,
        isProducts, isProductsBrands, isProductsSubBrands, isProduct, isProductsCategory, isProductsByCategory, isBanners
    }}>{children}</ProductsContext.Provider>;
}
